import React, { useRef } from 'react';
import { View, LayoutChangeEvent } from 'react-native';
import { SizeLimitContext } from '../../contexts/SizeLimitContext';

export const ContainerPreview = ({
  children,
  shouldUseContainerDimensions,
  onContainerDimensionsChange,
}: {
  children: React.ReactNode;
  shouldUseContainerDimensions?: boolean;
  onContainerDimensionsChange?: (dimensions: { width: number; height: number }) => void;
}) => {
  const containerRef = useRef<View>(null);

  const handleLayout = (event: LayoutChangeEvent) => {
    const dimensions = event.nativeEvent.layout;
    onContainerDimensionsChange?.(dimensions);
  };
  if (shouldUseContainerDimensions) {
    return (
      <View style={[{ width: '100%', height: '100%' }]}>
        <View
          ref={containerRef}
          style={{ width: '100%', height: '100%', justifyContent: 'center' }}
          onLayout={handleLayout}
        >
          <SizeLimitContext.Provider value={{ width: 0, height: 0 }}>{children}</SizeLimitContext.Provider>
        </View>
      </View>
    );
  } else {
    return children;
  }
};
